export const VALIDATE_ACTION = 'src/Login/VALIDATE_ACTION'
export const SET_ISLOGGEDIN_ACTION = 'src/Login/SET_ISLOGGEDIN_ACTION'
export const STEP_REDIRECT_ACTION = 'src/Login/STEP_REDIRECT_ACTION'
export const SET_REFERRAL = 'src/Callback/SET_REFERRAL'
export const SET_PREVIEWDATA = 'src/Callback/SET_PREVIEWDATA'


// WEBPACK FOOTER //
// ./src/conteiners/Callback/constants.js